/**
 * @file ログイン済みユーザーの基本情報を管理するステート
 *
 * ログイン後のユーザーIDとメール認証状態を保持する。
 * メール未認証の場合は通知が表示されるため、
 * is_verified_emailが画面制御に使用される。
 * セッションストレージに永続化される。
 */
import { atom } from 'recoil';
import persistAtom from './recoilPersist';

/** ログインユーザー情報の型 */
export type LoginInfo = {
  /** ユーザーID */
  userId: string;
  /** メールアドレスが認証済みかどうか */
  is_verified_email: boolean;
};

export const loginInfoState = atom<LoginInfo>({
  key: 'loginInfoState',
  default: {
    userId: '',
    is_verified_email: false,
  },
  effects_UNSTABLE: [persistAtom],
});

export default loginInfoState;
